module.exports = __webpack_public_path__ + "img/10.63a350cd.jpg";